import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { palette } from 'c1ui'

export const useStyles = makeStyles(() => {
    return createStyles({
        relativeText: {
            '&:hover': {
                backgroundColor: palette.grey[100],
            },
        },
        tooltipText: {
            backgroundColor: palette.grey[100],
            color: palette.text.primary,
        },
        overdue: {
            color: palette.error.main,
        },
        icon: {
            fontSize: 16,
            display: 'block',
            marginLeft: 0,
        },
        error: {
            color: palette.error.dark,
        },
    })
})
